import { ca } from '@cian/analytics';

export function trackBrochureClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'Click_sopr',
    label: 'brochure',
    useLastProducts: true,
  });
}
